<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="breadCrumb"></ZD-bread-crumb>
    </div>

    <div class="list-content-div">
      <div class="list-header-row">
        <div class="list-header-title-div">送桩活动服务列表</div>
        <div class="page-action-btns flex">
          <button class="common-bg-button" @click="showUserVerify">用户验证开关</button>
          <button class="common-bg-button" @click="handleEditOrder">活动订单编辑</button>
          <button class="common-bg-button" @click="toggleFilters">高级筛选</button>
          <button class="common-bg-button" @click="handleExport">导 出</button>
        </div>
      </div>

      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input clearable v-model="queryInfo.keyWord" size="small"
                placeholder="请输入活动订单编号/用户手机号/用户姓名"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">订单状态</p>
              <el-select v-model="queryInfo.orderStatus" size="small" clearable placeholder="请选择" style="width: 100%">
                <el-option label="已报名" value="COMMIT" />
                <el-option label="待签约" value="TO_SIGN" />
                <el-option label="已签约" value="IN_SIGN" />
                <el-option label="待安装" value="TO_INSTALL" />
                <el-option label="待激活" value="TO_ACTIVATION" />
                <el-option label="使用中" value="IN_USE" />
                <el-option label="待守约" value="TO_COMPLIANCE" />
                <el-option label="已逾期" value="IN_OVERDUE" />
                <el-option label="已违约" value="IN_DEFAULTED" />
                <el-option label="解约申请中" value="IN_CANCELING" />
                <el-option label="已解约(买断)" value="IN_CANCELLED_BUYOUT" />
                <el-option label="已解约(退出)" value="IN_CANCELLED_REFUNDED" />
                <el-option label="已解约(违约)" value="IN_CANCELLED_DEFAULTED" />
                <el-option label="已解约(到期)" value="IN_EXPIRED" />
                <el-option label="已退出" value="IN_CLOSE" />
                <el-option label="待激活签约" value="TO_RESET_SIGN" />
                <el-option label="暂停使用" value="PAUSE" />
                <el-option label="提前买断·使用中" value="BUYOUT_IN_USE_STATUS" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">会员服务状态</p>
              <el-select v-model="queryInfo.flowStatus" size="small" clearable placeholder="请选择" style="width: 100%">
                <el-option label="正常" value="COMMON" />
                <el-option label="即将到期" value="ABOUT_TO_EXPIRE" />
                <el-option label="已到期" value="EXPIRED" />
                <el-option label="已解约" value="CANCELED" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">解约类型</p>
              <el-select v-model="queryInfo.refundReasonType" size="small" clearable placeholder="请选择"
                style="width: 100%">
                <el-option label="用户未安装解约" value="NOT_INSTALL_CANCEL" />
                <el-option label="到期自动解约" value="AUTO_CANCEL" />
                <el-option label="满共享度电自动解约" value="ALL_SHARE_AUTO_CANCEL" />
                <el-option label="未解约" value="NOT_CANCEL" />
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">买断类型</p>
              <el-select v-model="queryInfo.buyoutReasonType" size="small" clearable placeholder="请选择"
                style="width: 100%">
                <el-option label="提前买断解约" value="ADVANCE_BUY_OUT" />
                <el-option label="违约自动买断" value="HEART_AUTO_BUY_OUT" />
                <el-option label="未买断" value="NOT_BUY_OUT" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">所属一级代理商</p>
              <el-select v-model="queryInfo.agentLevel1Phone" size="small" clearable placeholder="请选择" filterable
                style="width: 100%" @focus="fetchAgentLevel1List" @change="onAgentLevel1Change">
                <el-option v-for="item in agentLevel1Options" :key="item.phone" :label="item.agentName"
                  :value="item.phone" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">所属二级代理商</p>
              <el-select v-model="queryInfo.agentLevel2Phones" size="small" clearable placeholder="请先选择一级代理商"
                multiple filterable style="width: 100%" :disabled="!queryInfo.agentLevel1Phone">
                <el-option v-for="item in agentLevel2Options" :key="item.phone" :label="item.agentName"
                  :value="item.phone" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">客服联系状态</p>
              <el-select v-model="queryInfo.activityOrderContractStatus" size="small" clearable placeholder="请选择"
                style="width: 100%">
                <el-option label="待联系" value="WAIT_CONTRACT" />
                <el-option label="已联系" value="CONTRACTED" />
                <el-option label="未联系上" value="NOT_CONTRACT" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">安装状态</p>
              <el-select v-model="queryInfo.installStatus" size="small" clearable placeholder="请选择" style="width: 100%">
                <el-option label="未勘察未安装" value="INVESTIGATION_INSTALL_INIT" />
                <el-option label="已勘察已安装" value="INVESTIGATION_INSTALL_COMPLETED" />
                <el-option label="已勘察不安装" value="INVESTIGATION_FINISHED_NOT_INSTALL" />
                <el-option label="未勘察不安装" value="INVESTIGATION_INIT_NOT_INSTALL" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">是否违规买断</p>
              <el-select v-model="queryInfo.isViolationBuyout" size="small" clearable placeholder="请选择"
                style="width: 100%">
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-top: 16px;">
            <el-col :span="12">
              <p class="margin-bottom-5 font-14">订单创建时间</p>
              <el-date-picker v-model="queryInfo.createTimeRange" size="small" type="datetimerange" range-separator="至"
                start-placeholder="开始日期时间" end-placeholder="结束日期时间" value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%" @change="handleCreateTimeRangeChange"></el-date-picker>
            </el-col>
            <el-col :span="12">
              <p class="margin-bottom-5 font-14">设备绑定时间</p>
              <el-date-picker v-model="queryInfo.bindTimeRange" size="small" type="datetimerange" range-separator="至"
                start-placeholder="开始日期时间" end-placeholder="结束日期时间" value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%" @change="handleBindTimeRangeChange"></el-date-picker>
            </el-col>
          </el-row>
        </div>
        <div class="page-action-btns flex margin-tb-10">
          <div class="flex-grow-1"></div>
          <button class="common-bg-button" @click="reset">重 置</button>
          <button class="common-bg-button" @click="search">搜 索</button>
        </div>
      </div>

      <el-table :data="serviceList" size="small" border style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="createTime" label="报名创建时间" min-width="140">
          <template slot-scope="{ row }">{{ row.createTime || row.createdWhen || '-' }}</template>
        </el-table-column>
        <el-table-column prop="purchaseName" label="购买名称" min-width="140">
          <template slot-scope="{ row }">{{ row.purchaseName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="activityOrderNo" label="活动订单编号" min-width="210">
          <template slot-scope="{ row }">
            <span class="link-text" @click="handleActivityOrderNoClick(row)">{{ row.activityOrderNo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="relationGoodsOrderNo" label="关联商品订单编号" min-width="220">
          <template slot-scope="{ row }">{{ row.relationGoodsOrderNo || row.mapNo || '-' }}</template>
        </el-table-column>
        <el-table-column prop="userName" label="用户姓名" min-width="100">
          <template slot-scope="{ row }">{{ row.userName || row.name || '-' }}</template>
        </el-table-column>
        <el-table-column prop="userMobile" label="用户手机号" min-width="130">
          <template slot-scope="{ row }">{{ row.userMobile || row.mobile || '-' }}</template>
        </el-table-column>
        <el-table-column prop="orderStatus" label="订单状态" min-width="120">
          <template slot-scope="{ row }">
            <span>{{ getOrderStatusText(row) }}</span>
          </template>
        </el-table-column>
        <!-- 新增 -->
        <el-table-column prop="pileInstallOrderNo" label="是否已安装" min-width="100">
          <template slot-scope="{ row }">
            <span v-if="row.pileInstallOrderNo === 'Y'">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="activityOrderInstallStatusName" label="安装状态" min-width="100">
        </el-table-column>
        <el-table-column prop="actualAmountStatus" label="会员服务状态" min-width="120">
          <template slot-scope="{ row }">{{ getMemberServiceStatusText(row.actualAmountStatus) }}</template>
        </el-table-column>
        <el-table-column prop="totalUseMonths" label="会员服务累计使用时长（月）" min-width="190">
          <!-- <template slot-scope="{ row }">{{ row.flowServiceTotalUsed != null ? row.flowServiceTotalUsed :
            (row.actualAmountCumulativeMonths != null ? row.actualAmountCumulativeMonths : '-') }}</template> -->
        </el-table-column>
        <el-table-column prop="flowServicePayment" label="会员服务累计支付（元）" min-width="170">
          <template slot-scope="{ row }">{{ row.flowServicePayment != null ? row.flowServicePayment :
            (row.actualAmountTotal != null ? row.actualAmountTotal : '-') }}</template>
        </el-table-column>
        <!-- <el-table-column prop="actualAmountStatusName" label="流量服务状态" min-width="100">
          <template slot-scope="{ row }">
            {{ row.actualAmountStatusName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="flowServiceTotalUsed" label="流量服务累计使用时长" min-width="120">
          <template slot-scope="{ row }">{{ row.flowServiceTotalUsed != null ? row.flowServiceTotalUsed :
            (row.actualAmountCumulativeMonths != null ? row.actualAmountCumulativeMonths : '-') }}</template>
        </el-table-column>
        <el-table-column prop="flowServicePayment" label="流量服务累计支付（元）" min-width="140">
          <template slot-scope="{ row }">{{ row.flowServicePayment != null ? row.flowServicePayment :
            (row.actualAmountTotal != null ? row.actualAmountTotal : '-') }}</template>
        </el-table-column> -->
        <el-table-column prop="currentServiceStartTime" label="当前服务开始时间" min-width="170">
          <template slot-scope="{ row }">{{ row.currentServiceStartTime || row.actualAmountStartTime || '-'
          }}</template>
        </el-table-column>
        <el-table-column prop="currentServiceEndTime" label="当前服务到期时间" min-width="170">
          <template slot-scope="{ row }">{{ row.currentServiceEndTime || row.actualAmountEndTime || '-' }}</template>
        </el-table-column>
        <el-table-column prop="flowServiceRemainDays" label="当前会员服务剩余天数" min-width="150">
          <template slot-scope="{ row }">{{ row.flowServiceRemainDays != null ? row.flowServiceRemainDays :
            (row.actualAmountDaysRemaining != null ? row.actualAmountDaysRemaining : '-') }}</template>
        </el-table-column>
        <el-table-column prop="flowServiceRenewTime" label="会员待续费时间" min-width="160">
          <template slot-scope="{ row }">
            <span v-if="row.flowServiceRenewTime" class="link-text" @click="handleRenewTimeClick(row)">{{
              row.flowServiceRenewTime }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="flowFeeRenewWarnDays" label="会员待续费预警天数" min-width="180">
          <template slot-scope="{ row }">
            <span v-if="row.flowFeeRenewWarnDays" class="link-text" @click="handleWarnDaysClick(row)">{{
              row.flowFeeRenewWarnDays }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="holdAgreement" label="商家代扣状态" min-width="140">
          <template slot-scope="{ row }">
            <span v-if="row.merchantWithholdStatusText">{{ row.merchantWithholdStatusText }}</span>
            <span v-else-if="row.holdAgreement === 'Y'">已签约</span>
            <span v-else-if="row.holdAgreement === 'N'">未签约</span>
            <span v-else>{{ row.holdAgreement || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bindTime" label="设备绑定时间" min-width="170">
          <template slot-scope="{ row }">{{ row.bindTime || '-' }}</template>
        </el-table-column>
        <el-table-column prop="pileCode" label="充电桩设备编号" min-width="140">
          <template slot-scope="{ row }">{{ row.pileCode || '-' }}</template>
        </el-table-column>
        <el-table-column prop="switchDeviceAssetNo" label="充电桩设备资产编号" min-width="170">
          <template slot-scope="{ row }">{{ row.pileAssetCode || '-' }}</template>
        </el-table-column>
        <el-table-column prop="refundReasonTypeName" label="解约类型" min-width="140">
          <template slot-scope="{ row }">{{ row.refundReasonTypeName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="cancelRequestTime" label="用户解约申请时间" min-width="170">
          <template slot-scope="{ row }">{{ row.cancelRequestTime || '-' }}</template>
        </el-table-column>
        <el-table-column prop="terminateCompleteTime" label="解约完成时间" min-width="170">
          <template slot-scope="{ row }">{{ row.terminateCompleteTime || row.cancelFinishTime || '-' }}</template>
        </el-table-column>
        <el-table-column prop="terminateReason" label="用户解约原因" min-width="200" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.terminateReason || row.cancelReason || '-' }}</template>
        </el-table-column>
        <el-table-column prop="buyoutReasonTypeName" label="买断类型" min-width="170">
          <template slot-scope="{ row }">{{ row.buyoutReasonTypeName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="buyOutCancelFinishTime" label="买断完成时间" min-width="170">
          <template slot-scope="{ row }">{{ row.buyOutCancelFinishTime || '-' }}</template>
        </el-table-column>
        <el-table-column prop="isViolationBuyout" label="是否违规买断" min-width="140">
          <template slot-scope="{ row }">
            <span v-if="row.isViolationBuyout === '1'">是</span>
            <span v-else-if="row.isViolationBuyout === '0'">否</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="refundCancelReason" label="违规买断原因" min-width="200" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.refundCancelReason || '-' }}</template>
        </el-table-column>
        <el-table-column prop="installFailReason" label="不安装/不签约原因" min-width="200" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.installFailReason || '-' }}</template>
        </el-table-column>
        <el-table-column prop="activityOrderOriginPrice" label="买断免押扣款金额（元）" min-width="190">
          <template slot-scope="{ row }">{{ row.activityOrderOriginPrice || '-'
          }}</template>
        </el-table-column>
        <el-table-column prop="sesameStatus" label="芝麻信用状态" min-width="140">
          <template slot-scope="{ row }">
            <span v-if="row.sesameStatus === 'Y'">已签约</span>
            <span v-else-if="row.sesameStatus === 'N'">未签约</span>
            <span v-else>{{ row.sesameStatus || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="province" label="省" min-width="120" />
        <el-table-column prop="city" label="市" min-width="120" />
        <el-table-column prop="district" label="区" min-width="120">
          <template slot-scope="{ row }">{{ row.district || row.area || '-' }}</template>
        </el-table-column>
        <!-- <el-table-column prop="isEndDisbursement" label="是否满足补贴发放" min-width="160">
          <template slot-scope="{ row }">
            <span v-if="row.isEndDisbursement == 1 || row.isEndDisbursement === '1'">是</span>
            <span v-else-if="row.isEndDisbursement == 0 || row.isEndDisbursement === '0'"></span>
            <span v-else>-</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="endDisbursementTime" label="是否满足补贴发放时间" min-width="170" />
        <el-table-column prop="province" label="省" min-width="120" />
        <el-table-column prop="city" label="市" min-width="120" />
        <el-table-column prop="district" label="区" min-width="120">
          <template slot-scope="{ row }">{{ row.district || row.area || '-' }}</template>
        </el-table-column> -->
        <el-table-column prop="detailAddress" label="详细地址" min-width="220" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.detailAddress || row.address || '-' }}</template>
        </el-table-column>
        <el-table-column prop="agentName" label="所属代理商" min-width="140">
          <template slot-scope="{ row }">{{ row.agentName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="agentPhone" label="代理商账号" min-width="130">
          <template slot-scope="{ row }">{{ row.agentPhone || '-' }}</template>
        </el-table-column>
        <el-table-column prop="agentLevel" label="代理商级别" min-width="120">
          <template slot-scope="{ row }">{{ getAgentLevelText(row.agentLevel) }}</template>
        </el-table-column>
        <el-table-column prop="parentAgentName" label="上级代理" min-width="140">
          <template slot-scope="{ row }">{{ row.parentAgentName || '-' }}</template>
        </el-table-column>
      </el-table>

      <div class="list-pagination">
        <el-pagination background layout="total, prev, pager, next, sizes, jumper" :current-page="pagination.current"
          :page-size="pagination.pageSize" :page-sizes="[10, 20, 50, 100]" :total="pagination.total"
          @current-change="handleCurrentChange" @size-change="handleSizeChange" />
      </div>

      <el-dialog title="" :visible.sync="verifyDialogVisible" width="520px" center custom-class="verify-dialog-center"
        @close="handleVerifyClose">
        <div class="verify-dialog-body">
          <div class="verify-item center">
            <span class="verify-label">单用户验证开关</span>
          </div>
          <div class="verify-item center">
            <span class="verify-label">同一手机号仅申请一次</span>
          </div>
          <div class="verify-item center">
            <el-radio-group v-model="verifyForm.singleApplyFlag" size="small" class="verify-radio-group">
              <el-radio label="ON">开启</el-radio>
              <el-radio label="OFF">关闭</el-radio>
            </el-radio-group>
          </div>
        </div>
        <span slot="footer" class="dialog-footer center">
          <el-button type="primary" @click="handleVerifySubmit">提 交</el-button>
          <el-button @click="handleVerifyClose">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryInfo: {
        keyWord: "",
        orderStatus: "",
        terminateType: "",
        buyoutType: "",
        customerServiceStatus: "",
        isViolationBuyout: "",
        energyAuditClassify: "",
        agentLevel1Phone: "",
        agentLevel2Phones: [],
        createTimeRange: [],
        pageNum: 1,
        pageSize: 10,
        accountIds: [],
      },
      showMultiQuerys: false,
      verifyDialogVisible: false,
      verifyForm: {
        mobile: "",
        singleApplyFlag: "ON",
      },
      selections: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      serviceList: [],
      agentLevel1Options: [],
      agentLevel2Options: [],
      breadCrumb: [
        { name: "营销活动" },
        { name: "送桩活动" },
        { name: "送桩服务列表" },
      ],
    };
  },
  computed: {},
  mounted() {
    this.getListData(this.pagination, true);
  },
  methods: {
    // 清理查询参数，排除前端用的日期范围字段，处理代理商筛选
    cleanQueryInfo(queryInfo) {
      const _ = this;
      const clean = {};
      Object.keys(queryInfo).forEach(key => {
        if (key === 'createTimeRange' || key === 'bindTimeRange' || key === 'agentLevel1Phone' || key === 'agentLevel2Phones') return;
        const value = queryInfo[key];
        if (value !== null && value !== undefined && value !== '') {
          clean[key] = value;
        }
      });
      // accountIds: 单选一级则 [一级手机号, ...全部二级手机号]；二级非全部选中则 [选中的二级手机号]
      const level2Phones = queryInfo.agentLevel2Phones || [];
      const level2AllPhones = _.agentLevel2Options.map((o) => o.phone || o.agentPhone).filter(Boolean);
      const isLevel2AllSelected = level2Phones.length > 0 && level2Phones.length === level2AllPhones.length;
      if (level2Phones.length > 0 && !isLevel2AllSelected) {
        clean.accountIds = [...level2Phones];
      } else if (queryInfo.agentLevel1Phone) {
        clean.accountIds = [
          queryInfo.agentLevel1Phone,
          ...level2AllPhones,
        ];
      } else {
        clean.accountIds = [];
      }
      return clean;
    },
    // 订单创建时间变化时，同一天自动填充 00:00:00 和 23:59:59（参考 emptySwitchOrderList 用户申请时间）
    handleCreateTimeRangeChange(val) {
      if (val && val.length === 2) {
        const [start, end] = val;
        const startDate = start ? String(start).slice(0, 10) : '';
        const endDate = end ? String(end).slice(0, 10) : '';
        if (startDate && endDate && startDate === endDate) {
          this.queryInfo.createTimeRange = [
            startDate + ' 00:00:00',
            endDate + ' 23:59:59'
          ];
        }
      }
    },
    // 设备绑定时间变化时，同一天自动填充 00:00:00 和 23:59:59
    handleBindTimeRangeChange(val) {
      if (val && val.length === 2) {
        const [start, end] = val;
        const startDate = start ? String(start).slice(0, 10) : '';
        const endDate = end ? String(end).slice(0, 10) : '';
        if (startDate && endDate && startDate === endDate) {
          this.queryInfo.bindTimeRange = [
            startDate + ' 00:00:00',
            endDate + ' 23:59:59'
          ];
        }
      }
    },
    // 订单创建时间范围转 createFromTime/createToTime，同一天为 00:00:00 ~ 23:59:59，跨天保留所选时分秒
    buildCreateTimeRange(queryForApi) {
      if (!queryForApi.createTimeRange || !Array.isArray(queryForApi.createTimeRange) || queryForApi.createTimeRange.length !== 2) {
        queryForApi.createFromTime = '';
        queryForApi.createToTime = '';
      } else {
        const [start, end] = queryForApi.createTimeRange;
        const startDate = start ? String(start).slice(0, 10) : '';
        const endDate = end ? String(end).slice(0, 10) : '';
        if (startDate && endDate && startDate === endDate) {
          queryForApi.createFromTime = startDate + ' 00:00:00';
          queryForApi.createToTime = endDate + ' 23:59:59';
        } else {
          queryForApi.createFromTime = start || '';
          queryForApi.createToTime = end || '';
        }
      }
      delete queryForApi.createTimeRange;
    },
    // 设备绑定时间范围转 bindFromTime/bindToTime，同一天为 00:00:00 ~ 23:59:59，跨天保留所选时分秒
    buildBindTimeRange(queryForApi) {
      if (!queryForApi.bindTimeRange || !Array.isArray(queryForApi.bindTimeRange) || queryForApi.bindTimeRange.length !== 2) {
        queryForApi.bindFromTime = '';
        queryForApi.bindToTime = '';
      } else {
        const [start, end] = queryForApi.bindTimeRange;
        const startDate = start ? String(start).slice(0, 10) : '';
        const endDate = end ? String(end).slice(0, 10) : '';
        if (startDate && endDate && startDate === endDate) {
          queryForApi.bindFromTime = startDate + ' 00:00:00';
          queryForApi.bindToTime = endDate + ' 23:59:59';
        } else {
          queryForApi.bindFromTime = start || '';
          queryForApi.bindToTime = end || '';
        }
      }
      delete queryForApi.bindTimeRange;
    },
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);

      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 1;
      } else {
        _.pagination.current = pagination.current;
        _.queryInfo.pageNum = pagination.current;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.queryInfo.activityExtendTypeEnum = "FREE_PILE_ACTIVITY_PAY";

      const queryForApi = { ..._.queryInfo };
      _.buildCreateTimeRange(queryForApi);
      _.buildBindTimeRange(queryForApi);

      const cleanQueryInfo = _.cleanQueryInfo(queryForApi);
      cleanQueryInfo.corpNo = _.$store.state.corpNo;
      cleanQueryInfo.activityExtendTypeEnum = "FREE_PILE_ACTIVITY_PAY";
      cleanQueryInfo.pageNum = _.queryInfo.pageNum;
      cleanQueryInfo.pageSize = _.queryInfo.pageSize;
      _.$H.post(_, _.$A.activityOrder.circuitBreakerActivityOrderPage, cleanQueryInfo).then(res => {
        const payload = res?.data?.data ?? res?.data ?? res ?? {};
        _.serviceList = payload?.content ?? [];
        _.pagination.total = payload?.totalElements ?? payload?.total ?? 0;
        _.$U.hideLoading(_);
      }).catch(() => {
        _.serviceList = [];
        _.pagination.total = 0;
        _.$U.hideLoading(_);
      });
    },
    toggleFilters() {
      this.showMultiQuerys = !this.showMultiQuerys;
      if (this.showMultiQuerys && this.agentLevel1Options.length === 0) {
        this.fetchAgentLevel1List();
      }
    },
    fetchAgentLevel1List() {
      const _ = this;
      const apiUrl = _.$A.agent?.findByPage;
      if (!apiUrl) return;
      const params = {
        activityType: "FREE_PILE_ACTIVITY",
        agentLevel: 1,
        pageNum: 0,
        pageSize: 9999,
      };
      _.$H.post(_, apiUrl, params).then((res) => {
        const payload = res?.data?.data ?? res?.data ?? {};
        const list = payload?.content ?? payload?.list ?? payload?.records ?? [];
        const arr = Array.isArray(list) ? list : [];
        const seen = new Set();
        _.agentLevel1Options = arr.filter((item) => {
          const phone = item.phone || item.agentPhone || "";
          if (!phone || seen.has(phone)) return false;
          seen.add(phone);
          return true;
        });
      }).catch(() => {
        _.agentLevel1Options = [];
      });
    },
    onAgentLevel1Change() {
      this.queryInfo.agentLevel2Phones = [];
      this.agentLevel2Options = [];
      if (!this.queryInfo.agentLevel1Phone) return;
      const level1Agent = this.agentLevel1Options.find(
        (item) => (item.phone || item.agentPhone) === this.queryInfo.agentLevel1Phone
      );
      if (level1Agent && level1Agent.id) {
        this.fetchAgentLevel2List(level1Agent.id);
      }
    },
    fetchAgentLevel2List(parentId) {
      const _ = this;
      const apiUrl = _.$A.agent?.findByPage;
      if (!apiUrl || !parentId) {
        _.agentLevel2Options = [];
        return;
      }
      const params = {
        activityType: "FREE_PILE_ACTIVITY",
        agentLevel: 2,
        parentId,
        pageNum: 0,
        pageSize: 9999,
      };
      _.$H.post(_, apiUrl, params).then((res) => {
        const payload = res?.data?.data ?? res?.data ?? {};
        const list = payload?.content ?? payload?.list ?? payload?.records ?? [];
        const arr = Array.isArray(list) ? list : [];
        const seen = new Set();
        _.agentLevel2Options = arr.filter((item) => {
          const phone = item.phone || item.agentPhone || "";
          if (!phone || seen.has(phone)) return false;
          seen.add(phone);
          return true;
        });
      }).catch(() => {
        _.agentLevel2Options = [];
      });
    },
    reset() {
      this.queryInfo = {
        keyWord: "",
        orderStatus: "",
        flowStatus: "",
        refundReasonType: "",
        buyoutReasonType: "",
        customerServiceStatus: "",
        activityOrderInstallStatusName: "",
        isViolationBuyout: "",
        energyAuditClassify: "",
        agentLevel1Phone: "",
        agentLevel2Phones: [],
        createTimeRange: [],
        bindTimeRange: [],
        pageNum: 1,
        pageSize: 10,
      };
      this.agentLevel2Options = [];
      this.getListData(this.pagination, true);
    },
    search() {
      this.getListData(this.pagination, true);
    },
    handleSelectionChange(sels) {
      this.selections = sels;
    },
    handleCurrentChange(page) {
      this.pagination.current = page;
      this.getListData(this.pagination, false);
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.current = 1;
      this.getListData(this.pagination, true);
    },
    showUserVerify() {
      const target = this.selections && this.selections[0] ? this.selections[0] : {};
      this.verifyForm.mobile = target.userMobile || target.mobile || "";
      this.verifyForm.singleApplyFlag = "ON";
      this.verifyDialogVisible = true;
    },
    handleVerifySubmit() {
      const _ = this;
      _.$U.showLoading(_);
      const params = {
        keyWord: _.verifyForm.singleApplyFlag === "ON" ? "Y" : "N",
      };
      _.$H
        .post(_, _.$A.activityOrder.setCheckOnce, params)
        .then((res) => {
          if (res?.data?.status === 200) {
            _.$message.success("设置成功");
            _.verifyDialogVisible = false;
          } else {
            _.$message.error(res?.data?.message || res?.data?.msg || "设置失败");
          }
          _.$U.hideLoading(_);
        })
        .catch(() => {
          _.$U.hideLoading(_);
          _.$message.error("请求失败，请稍后重试");
        });
    },
    handleVerifyClose() {
      this.verifyDialogVisible = false;
    },
    handleEditOrder() {
      if (!this.selections || this.selections.length !== 1) {
        this.$message.error("请选择一条记录");
        return;
      }
      const row = this.selections[0];
      const activityOrderNo = row.activityOrderNo;
      if (!activityOrderNo) {
        this.$message.warning("订单编号不存在");
        return;
      }
      this.$router.push({
        name: "pileDonationActivityDetail",
        query: { activityOrderNo, mode: "edit" },
      });
    },
    handleExport() {
      const _ = this;
      _.$U.showLoading(_);

      const queryForApi = { ..._.queryInfo };
      _.buildCreateTimeRange(queryForApi);
      _.buildBindTimeRange(queryForApi);

      const exportQueryInfo = _.cleanQueryInfo(queryForApi);
      exportQueryInfo.corpNo = _.$store.state.corpNo;
      exportQueryInfo.activityExtendTypeEnum = "FREE_PILE_ACTIVITY_PAY";

      _.$H
        .post(_, _.$A.activityOrder.circuitBreakerActivityPileActivityOrderExcel, exportQueryInfo)
        .then((res) => {
          _.$U.hideLoading(_);
          const data = res?.data?.data;
          if (data) {
            if (data.base64 || data.fileName) {
              _.$U.saveExcelFile(data);
              _.$message.success("导出成功");
            } else if (data.filePath) {
              const downloadUrl = data.filePath.startsWith("http")
                ? data.filePath
                : `/api/d1${data.filePath.startsWith("/") ? "" : "/"}${data.filePath}`;
              window.open(downloadUrl, "_blank");
              _.$message.success("导出成功");
            } else {
              _.$message.error("导出失败：未获取到文件信息");
            }
          } else {
            _.$message.error(res?.data?.msg || res?.data?.message || "导出失败");
          }
        })
        .catch(() => {
          _.$U.hideLoading(_);
          _.$message.error("导出失败");
        });
    },
    handleActivityOrderNoClick(row) {
      const activityOrderNo = row.activityOrderNo;
      if (!activityOrderNo) {
        this.$message.warning("订单编号不存在");
        return;
      }
      this.$router.push({
        name: "pileDonationActivityDetail",
        query: { activityOrderNo },
      });
    },
    handleRenewTimeClick() {
      this.$message.success("待续费时间点击（占位）");
    },
    handleWarnDaysClick() {
      this.$message.success("预警天数点击（占位）");
    },
    handleWithholdStatusClick() {
      this.$message.success("商家代扣状态点击（占位）");
    },
    handleTerminateTypeClick() {
      this.$message.success("解约类型点击（占位）");
    },
    handleBuyoutTypeClick() {
      this.$message.success("买断类型点击（占位）");
    },
    handleViolationReasonClick() {
      this.$message.success("违规原因点击（占位）");
    },
    getOrderStatusText(row) {
      const status = (row.orderStatus || row.activityStatus || row.orderStatusText || row.activityOrderStatusName || "").trim();
      const map = {
        COMMIT: "已报名",
        TO_SIGN: "待签约",
        IN_SIGN: "已签约",
        TO_INSTALL: "待安装",
        TO_ACTIVATION: "待激活",
        IN_USE: "使用中",
        TO_COMPLIANCE: "待守约",
        IN_OVERDUE: "已逾期",
        IN_DEFAULTED: "已违约",
        IN_CANCELING: "解约申请中",
        IN_CANCELLED_BUYOUT: "已解约(买断)",
        IN_CANCELLED_REFUNDED: "已解约(退出)",
        IN_CANCELLED_DEFAULTED: "已解约(违约)",
        IN_EXPIRED: "已解约(到期)",
        IN_CLOSE: "已退出",
        TO_RESET_SIGN: "待激活签约",
        PAUSE: "暂停使用",
        BUYOUT_IN_USE_STATUS: "提前买断·使用中",
      };
      if (!status) return "-";
      return map[status] || (typeof row.activityOrderStatusName === "string" ? row.activityOrderStatusName : status);
    },
    getFlowServiceStatusText(row) {
      const status = (
        row.actualAmountStatus ||
        row.flowStatus ||
        ""
      ).trim();
      const map = {
        COMMON: "正常",
        ABOUT_TO_EXPIRE: "即将到期",
        EXPIRED: "已到期",
        CANCELED: "已解约",
      };
      if (!status) return "-";
      return map[status] || (row.flowServiceStatusName || row.actualAmountStatusName || status);
    },
    getMemberServiceStatusText(status) {
      const map = {
        TO_EXPRIRED: "即将到期",
        EXPIRED: "已过期",
        TO_ACTIVE: "待激活",
        ACTIVE: "正常",
        IN_ACTIVE: "正常",
        EXPIRING_SOON: "即将到期",
        CANCELLED: "已解约（买断）",
        TO_RENEWED: "待续费",
      };
      if (!status) return "-";
      return map[status] || status;
    },
    getAgentLevelText(level) {
      const map = {
        LEVEL_ONE: "一级",
        LEVEL_TWO: "二级",
        LEVEL_THREE: "三级",
        "1": "一级",
        "2": "二级",
        "3": "三级",
        1: "一级",
        2: "二级",
        3: "三级",
      };
      return map[level] || map[String(level)] || level || "-";
    },
  },
};
</script>

<style lang="less" scoped>
.list-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.page-action-btns {
  gap: 12px;
}

.margin-tb-10 {
  margin: 10px 0;
}

.flex-grow-1 {
  flex-grow: 1;
}

.multi-query-div {
  padding: 16px;
  background: #f6f8fb;
  border-radius: 6px;
}

.list-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 0;
}

.verify-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  font-size: 20px;

  &.center {
    justify-content: center;
  }
}

.verify-label {
  display: block;
  text-align: center;
  color: #333;
  font-size: 20px;
}

.verify-dialog-body {
  text-align: center;
  font-size: 20px;
}

.verify-radio-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 48px;
}

.link-text {
  color: #4182eb;
  cursor: pointer;
}

::v-deep .verify-dialog-center {
  .el-dialog__header {
    padding-top: 16px;
  }

  .el-dialog__body {
    padding: 32px 24px 16px;
    text-align: center;
  }

  .el-dialog__footer {
    padding: 24px 24px 32px;
    text-align: center;
  }

  .dialog-footer.center {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }

  .verify-radio-group,
  .el-radio-group {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 48px;
  }

  .el-radio {
    margin-right: 0;
  }
}
</style>
